// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconEnvelope = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M21 5H3v14h18zM5 8.301V17h14V8.301L12.894 14h-1.788zM17.463 7H6.537l5.357 5h.212z" />
  );
export default SvgIconEnvelope;
